import React, { useEffect } from "react";
import MainLayout from "../Common/MainLayout";
import {
  FaBuilding,
  FaClipboardList,
  FaWalking,
  FaCheckCircle,
  FaChartLine,
  FaChartPie,
} from "react-icons/fa";
import { toast } from "react-toastify";

import { connect } from "react-redux";
import PActions from "../../Stores/redux/Persisted/Actions";
import UnpActions from "../../Stores/redux/Unpersisted/Actions";

import api from "../../Services/Api/api";

const DashboardScreen = ({ stats, user, setScreenState }) => {
  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const totalOfficesP = await api.get("v1/district-admin/office", {
        filter: JSON.stringify({
          where: { district: user.district._id },
          countOnly: true,
        }),
      });
      const totalSchemesP = await api.get("v1/district-admin/scheme", {
        filter: JSON.stringify({
          where: { district: user.district._id },
          countOnly: true,
        }),
      });
      const totalVisitsP = await api.get("v1/district-admin/visit", {
        filter: JSON.stringify({
          where: { district: user.district._id },
          countOnly: true,
        }),
      });
      const totalApprovedReportsP = await api.get(
        "v1/district-admin/visit-report",
        {
          filter: JSON.stringify({
            where: { district: user.district._id, status: "approved" },
            countOnly: true,
          }),
        }
      );

      const recentVisitReportsP = await api.get(
        "v1/district-admin/visit-report",
        {
          filter: JSON.stringify({
            where: { district: user.district._id, status: { $ne: "pending" } },
            limit: 3,
            populate: [
              { path: "reporter" },
              {
                path: "visit",
                populate: [{ path: "office scheme" }],
              },
            ],
            sortby: "lastSubmitDate",
            order: -1,
          }),
        }
      );

      const { offices: totalOffices } = await totalOfficesP;
      const { schemes: totalSchemes } = await totalSchemesP;
      const { visits: totalVisits } = await totalVisitsP;
      const { visitReports: totalVisitReports } = await totalApprovedReportsP;
      const { visitReports: recentVisitReports } = await recentVisitReportsP;

      setScreenState({
        stats: {
          ...(stats || {}),
          totalOffices,
          totalSchemes,
          totalVisits,
          totalVisitReports,
          recentVisitReports,
        },
      });
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <MainLayout screenName="dashboard">
      <main className="dashboard-content">
        {/* Page Title & Breadcrumbs */}
        <div className="page-title">
          <h1>Dashboard</h1>
        </div>

        {/* Row 1: Key Stats */}
        <div className="stats-container">
          <div className="stat-card">
            <div className="icon">
              <FaBuilding />
            </div>
            <div className="details">
              <h4>{stats?.totalOffices}</h4>
              <span>Total Offices</span>
            </div>
          </div>

          <div className="stat-card">
            <div className="icon">
              <FaClipboardList />
            </div>
            <div className="details">
              <h4>{stats?.totalSchemes}</h4>
              <span>Total Schemes</span>
            </div>
          </div>

          <div className="stat-card">
            <div className="icon">
              <FaWalking />
            </div>
            <div className="details">
              <h4>{stats?.totalVisits}</h4>
              <span>Total Visits</span>
            </div>
          </div>

          <div className="stat-card">
            <div className="icon">
              <FaCheckCircle />
            </div>
            <div className="details">
              <h4>{stats?.totalVisitReports}</h4>
              <span>Approved Reports</span>
            </div>
          </div>
        </div>

        {/* Row 2: Recent Activities & Monthly Report Trends */}
        <div className="row-2">
          <div className="recent-activity">
            <h5>Recent Activities</h5>
            {stats?.recentVisitReports?.map((visitReport) => (
              <div key={visitReport._id} className="activity-item">
                <span className="activity-time">
                  {new Date(visitReport.lastSubmitDate).toLocaleString()}
                </span>
                <p>
                  {visitReport?.reporter?.designation ||
                    visitReport?.reporter?.name}{" "}
                  visited{" "}
                  <strong>
                    {
                      (visitReport?.visit?.scheme || visitReport?.visit?.office)
                        ?.name
                    }
                  </strong>
                </p>
              </div>
            ))}
          </div>

          <div className="graph-card">
            <h5>Monthly Report Trends</h5>
            <div className="graph-placeholder">
              <FaChartLine />
            </div>
          </div>
        </div>

        {/* Row 3: Office Wise & Circle Wise Pie Charts */}
        <div className="row-3">
          <div className="graph-card">
            <h5>Office Wise Visits</h5>
            <div className="graph-placeholder">
              <FaChartPie />
            </div>
          </div>

          <div className="graph-card">
            <h5>Circle Wise Visits</h5>
            <div className="graph-placeholder">
              <FaChartPie />
            </div>
          </div>
        </div>
      </main>
    </MainLayout>
  );
};

const SCREEN_NAME = "DASHBOARD_SCREEN";

const mapStateToProps = (state) => ({
  stats: state.vState[SCREEN_NAME]?.stats,
  user: state.pState.AUTH.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardScreen);
